import PropTypes from 'prop-types'
import { RdtWeeklyWorkingAverageType } from '../../models/rdt/rdt-weekly-working-average-type'
import { iso8601DurationPropType } from '../common/iso-8601-duration-prop-type'
import { rdtDurationPropType } from './rdt-duration-prop-type'

/**
 * @typedef {Object} RdtWeeklyWorking
 * @property {string} averageType - The way the weekly working average is calculated (quarterly or for a defined number
 *   of weeks or defined number of months).
 * @property {iso8601DurationPropType} maximumWorkingTime - Maximum weekly working time within the current calendar
 *   week. The weekly working time limit on average is considered.
 * @property {iso8601DurationPropType} maximumWorkingTimeOnAverage - Maximum allowed average weekly working time.
 * @property {number} numberOfAveragePeriods - If averageType is NUMBER_OF_WEEKS or NUMBER_OF_MONTHS, this value gives the number of
 *   weeks or months the average values are calculated for. Otherwise, this value is null.
 * @property {rdtDurationPropType} rawRemainingWorkingTime - The duration object of the remaining working time (raw).
 * @property {rdtDurationPropType} rawRemainingWorkingTimeOnAverage - The duration object of the average remaining
 *   working time (raw).
 * @property {rdtDurationPropType} remainingWorkingTime - The duration object of the remaining working time.
 * @property {iso8601DurationPropType} totalWorkingTimeOnAverage - The average total working time.
 */
export const rdtWeeklyWorkingPropType = PropTypes.shape({
    averageType: PropTypes.oneOf(Object.values(RdtWeeklyWorkingAverageType)),
    maximumWorkingTime: iso8601DurationPropType,
    maximumWorkingTimeOnAverage: iso8601DurationPropType,
    numberOfAveragePeriods: PropTypes.oneOf([PropTypes.number, null]),
    rawRemainingWorkingTime: rdtDurationPropType,
    rawRemainingWorkingTimeOnAverage: rdtDurationPropType,
    remainingWorkingTime: rdtDurationPropType,
    totalWorkingTimeOnAverage: iso8601DurationPropType
})
